###
# Photo uploader. Occupies the entire space of
# parent div. Shows on hover. Supports drag and drop.
###
module.exports = App.UploadImageComponent = Ember.Component.extend App.RegistrableMixin,
  classNames: 'upload-image-component'

  modelClassName: ''
  imagePropertyName: 'safeAvatarMedium'
  uploadMethod: 'uploadPhoto'

  classNameBindings: [ 'ghostMode:ghost-mode' ]
  ghostMode: false

  # Helper property
  backgroundImageStyle: (->
    photo = @get('model').get(@get 'imagePropertyName')
    result = if photo then "background-image: url(#{photo})" else ''
    result.htmlSafe()
  ).property('model.photo')

  # True when the file is uploading
  isUploading: false

  # True when when user drags content over
  isDragging: false

  handleFiles: (files) ->
    return if @get 'isUploading'
    return unless files[0]?.type.indexOf('image') != -1

    model = @get('model')
    data = new FormData()
    data.append 'file', files[0]

    method = @get('uploadMethod')
    model[method](data)
    .then ->
      model.reload()
      Em.Logger.log 'Загрузка картинки завершена'
    .always =>
      @set 'isUploading', false

  ###
  # Drag'n'drop event handlers
  ###
  preventDefault: (e) ->
    e.preventDefault()
    e.stopPropagation()

  dropHandler: (e) ->
    @preventDefault(e)
    @set 'isDragging', false
    return unless e.originalEvent.dataTransfer?.files?.length

    files = e.originalEvent.dataTransfer.files
    @handleFiles files

  dragOverHandler: (e) ->
    @preventDefault(e)

  dragEnterHandler: (e) ->
    @preventDefault(e)
    @set 'isDragging', true

  dragLeaveHandler: (e) ->
    @preventDefault(e)
    @set 'isDragging', false

  didInsertElement: ->
    window.model = @get('model.content')
    @$('.dragdrop').on('drop',      @dropHandler.bind(@))
    @$('.dragdrop').on('dragover',  @dragOverHandler.bind(@))
    @$('.dragdrop').on('dragenter', @dragEnterHandler.bind(@))
    @$('.dragdrop').on('dragleave', @dragLeaveHandler.bind(@))

  willDestroyElement: ->
    @$('.dragdrop').off('drop dragover dragenter dragleave')

  actions:
    # This action toggles 'Open As' dialog
    # The content of the input element changes
    # when user selects file(s) for upload
    toggleOpenFileDialog: ->
      @$('.hidden-file-input').trigger('click')

    # The action is fired when the content of input element
    # has been changed (e.g. user selected file)
    fileChanged: ->
      files = @$('.hidden-file-input').prop('files')
      @handleFiles files

